<template>
  <v-container fluid>
    <v-card outlined max-width="800">
      <div class="mx-6 my-4">
        <span class="title mb-10">
          Clients Sellers
        </span>
          <!-- background-color="rgba(48, 127, 255, 0.1)" -->
        <v-row class="mt-5">
          <v-col md="8">
            <v-select
              v-model="selected_client"
              :items="clients"
              outlined
              label="Select a client"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-combobox
          v-model="selected_sellers"
          :items="sellers_list"
          label="Sellect Sellers"
          clearable
          solo
          multiple
          id="sellers"
          item-text="seller"
          item-value="id"
          outlined
          class="mt-4"
        >
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              clearable
              @click:close="remove_seller( data.item.id )"
            >
              <strong>{{ data.item.seller }}</strong>
            </v-chip>
          </template>
        </v-combobox>
        <v-checkbox
          label="Importance"
          v-model="importance"
          class="mt-0 mb-2"
        ></v-checkbox>
        <v-btn
          large
          class="my-auto mb-3"
          color="purple"
          :loading="save_loader"
          @click="create_client_sellers"
          :disabled="!(selected_client && selected_sellers.length > 0 && !save_loader)"
        >Create Client Sellers</v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "clients-sellers-connect",
  data() {
    return {
      save_loader: false,
      selected_client: 0,
      selected_sellers: [],
      importance: true,
    };
  },
  computed: {
    sellers_list() {
      return this.$store.state.productionModule.sellers;
    },
    clients() {
      return this.$store.state.productionModule.clients_list.map((c) => (c.active && {
        text: c.text,
        value: c.value,
      }))
    },
    domains_list() {
      const domains = this.$store.state.productionModule.domains;
      return domains.length > 2 ? domains : [];
    },
  },
  methods: {
    remove_seller(seller_id) {
      this.selected_sellers = this.selected_sellers.filter(x => x.id !== seller_id);
    },
    loadSellers () {
      if (this.sellers_list.length == 0) {
        const payload = { task: 'loadSellers' };
        this.$store.dispatch('productionModule/general_api', payload)
        .then(res => {
          console.log('sellers', res.data)
          this.$store.commit('productionModule/SET_SELLERS', res.data.domains)
        })
      }
    },
    loadDomains() {
      if (this.domains_list.length == 0) {
        const payload = { task: "loadDomains" };
        this.$store
          .dispatch("productionModule/general_api", payload)
          .then((res) => {
            console.log("domains", res.data);
            this.$store.commit(
              "productionModule/SET_DOMAINS",
              res.data.domains
            );
          });
      }
    },
    create_client_sellers() {
      this.save_loader = true;
      const params = {
        task: "create_client_sellers",
        payload: {
          sellers: this.selected_sellers,
          client_id: this.selected_client,
          importance: this.importance,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", params)
        .then((res) => {
          const data = res.data.payload;
          console.log("create_client_sellers", data);
          const message = res.data.message;
          this.$emit('snackbar_show',{text: message})
        })
        .catch((err) => console.log("error", err))
        .finally(() => {this.save_loader = false;})
    },
  },

  created() {
      this.loadDomains();
      this.loadSellers();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/ClientsSellers.vue